import { useSelector, useDispatch } from 'react-redux'
import React, { useCallback, useState } from 'react'
import './style.css'
import { Form, Input, Card, Button, Avatar, message, notification } from 'antd'
import { editProfile } from '../../reducers/authReducer'
import { useDropzone } from 'react-dropzone'

const { Meta } = Card

const Profile = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)

  const [photo, setPhoto] = useState(null)
  const [form] = Form.useForm()
  const [isSaving, setIsSaving] = useState(false)

  const role = user.role.charAt(0).toUpperCase() + user.role.slice(1)

  const validateFile = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
    const maxSize = 1048576 // 1MB

    if (!allowedTypes.includes(file.type)) {
      message.error('Only JPG and PNG files are allowed')
      return false
    }
    if (file.size > maxSize) {
      message.error('File size must be less than 1 MB')
      return false
    }
    return true
  }

  const onFileChange = (event) => {
    const file = event[0]
    if (file && validateFile(file)) {
      setPhoto(file)
    }
  }

  const onDrop = useCallback((acceptedFiles) => {
    onFileChange(acceptedFiles)
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false
  })

  const onFinish = async (values) => {
    try {
      setIsSaving(true)

      if (!user.photo && !photo) {
        notification.error({
          message: 'Upload a profile photo'
        })
        setIsSaving(false)
        return
      }

      await dispatch(
        editProfile({
          ...values,
          photo
        })
      )
      setPhoto(null)
    } catch (error) {
      console.error(error)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="container">
      <div className="card">
        <span style={{ fontSize: '24px', fontWeight: 500 }}>User Details</span>
        <br />
        <br />
        <br />
        <div className="card-body">
          <div className="avatar">
            <Meta
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              avatar={
                <Avatar
                  size="large"
                  src={photo ? URL.createObjectURL(photo) : user.photo}
                />
              }
              title={
                <span style={{ fontSize: '18px', fontWeight: 500 }}>
                  {user.name}
                </span>
              }
            />
          </div>
          <div className="details">
            <h3 className="card-text">{'Role: ' + role}</h3>
            <h3 className="card-text">{'Username: @' + user.username}</h3>
            <h3 className="card-text">{'Email: ' + user.email}</h3>
            <h3 className="card-text">{'Mobile: ' + user.mobile}</h3>
          </div>
        </div>
      </div>

      <Card className="Form">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            name: user.name,
            email: user.email,
            username: user.username,
            mobile: user.mobile
          }}
        >
          <Form.Item
            name="name"
            label="Full Name"
            rules={[{ required: true, message: 'Please enter your name' }]}
          >
            <Input allowClear placeholder="Enter your full name" />
          </Form.Item>

          <Form.Item
            name="username"
            label="Username"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input allowClear placeholder="Enter your username" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: 'Please enter a valid email' }]}
          >
            <Input allowClear placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            name="mobile"
            label="Mobile"
            rules={[
              { required: true, message: 'Please enter your mobile number' }
            ]}
          >
            <Input maxLength={10} />
          </Form.Item>

          <Form.Item label="Profile Photo">
            <div
              {...getRootProps()}
              style={{
                border: '2px dashed #1890ff',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer'
              }}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                <p>Drop the image here ...</p>
              ) : (
                <p>Drag & drop an image here, or click to select</p>
              )}
              {photo && (
                <div style={{ marginTop: '15px' }}>
                  <img
                    src={URL.createObjectURL(photo)}
                    alt="Preview"
                    style={{ maxWidth: '150px', borderRadius: '8px' }}
                  />
                  <p>{photo.name}</p>
                </div>
              )}
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isSaving}
              disabled={!user.photo && !photo}
            >
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default Profile
